import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "header",
  style: {"margin-top":"6rem"}
}
const _hoisted_2 = { class: "detail-value" }
const _hoisted_3 = {
  key: 0,
  class: "detail"
}
const _hoisted_4 = {
  key: 1,
  class: "none"
}
const _hoisted_5 = { class: "detail-value" }
const _hoisted_6 = {
  key: 0,
  class: "detail"
}
const _hoisted_7 = {
  key: 1,
  class: "detail",
  style: {"list-style-type":"none"}
}
const _hoisted_8 = { class: "detail-value" }
const _hoisted_9 = {
  key: 0,
  class: "detail"
}
const _hoisted_10 = {
  key: 1,
  class: "detail",
  style: {"list-style-type":"none"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MainEmployments',
  setup(__props) {

const isArray = Array.isArray;

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("main.employments.header")), 1),
    _createVNode(_component_i18n_t, {
      class: "sub-header detail",
      keypath: "main.employments.google.header",
      tag: "div"
    }, {
      duration: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("main.employments.google.duration")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('main.employments.google.details'), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (!_unref(isArray)(item))
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_ctx.$rt(item)), 1))
            : (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (subItem, subIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: subIndex,
                      class: "detail"
                    }, _toDisplayString(_ctx.$rt(subItem)), 1))
                  }), 128))
                ])
              ]))
        ], 64))
      }), 128))
    ]),
    _createVNode(_component_i18n_t, {
      class: "sub-header detail",
      keypath: "main.employments.moloco.header",
      style: {"margin-top":"2rem"},
      tag: "div"
    }, {
      duration: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("main.employments.moloco.duration")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('main.employments.moloco.details'), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (!_unref(isArray)(item))
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(_ctx.$rt(item)), 1))
            : (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (subItem, subIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: subIndex,
                      class: "detail"
                    }, _toDisplayString(_ctx.$rt(subItem)), 1))
                  }), 128))
                ])
              ]))
        ], 64))
      }), 128))
    ]),
    _createVNode(_component_i18n_t, {
      class: "sub-header detail",
      keypath: "main.employments.karrot.header",
      style: {"margin-top":"2rem"},
      tag: "div"
    }, {
      duration: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("main.employments.karrot.duration")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('main.employments.karrot.details'), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (!_unref(isArray)(item))
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_ctx.$rt(item)), 1))
            : (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (subItem, subIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: subIndex,
                      class: "detail"
                    }, _toDisplayString(_ctx.$rt(subItem)), 1))
                  }), 128))
                ])
              ]))
        ], 64))
      }), 128))
    ])
  ], 64))
}
}

})